<template>
  <div class="video-player-container">
    <div
      class="small-top-header"
      v-if="showBackBotton"
    >
      <div class="small-top-header-content">
        <i
          class="fa fa-arrow-left"
          aria-hidden="true"
          @click.prevent="handleClose"
        ></i>
        <span class="title-text-white">{{ itemName }}</span>
        <div class="count-current-item">
          {{ currentItemCount }} / {{ totalItems }}
        </div>
      </div>
    </div>
    <closeIcon :handleClose="handleClose" />

    <div
      class="video_pc"
      :style="{ transform: containerTransform }"
      @touchstart="handleTouchStart"
      @touchend="handleTouchEnd"
      @touchmove="handleTouchMove"
    >
      <div
        class="spinner-border-loader text-primary"
        role="status"
        v-if="loadingItem"
      >
        <span class="loader-triangle"></span>
      </div>
      <Video
        v-else
        :video_url="handleReturnUrl()"
        :video_source="flix?.video_source"
        :video_poster="flix?.thumbnail ?? item_image"
        :access="handleCheckAccess(access, flix)"
        :is_small_device="smallDevice"
        @handleVideoHasEnded="handleVideoHasEnded"
        @handleCheckMoves="handleCheckMoves"
        @handleLoadNext="handleLoadNextVideo"
        @handleFullScreen="handleFullScreen"
      />

      <div
        class="pay-btn-container"
        v-if="!handleCheckAccess(access, flix) && !loadingItem"
        role="button"
        @click="handlePaymentModal"
      >
        <span class="lock-icon">
          <i
            class="fa fa-lock"
            aria-hidden="true"
          ></i>
        </span>
        Unlock This Episode
      </div>
    </div>
  </div>
</template>

<script>
import closeIcon from './close-icon.vue';
import Video from './components/video.vue';

export default {
  name: 'VideoContainer',
  components: { closeIcon, Video,  },
  props: {
    flix: {
      type: Object | null,
      required: true,
    },
    loadingItem: {
      type: Boolean,
      required: true,
    },
    itemName: {
      type: String,
      required: false,
    },
    totalItems: {
      type: Number,
      required: false,
    },
    currentItemCount: {
      type: Number,
      required: false,
    },
    access: {
      type: Boolean,
      required: true,
    },
    smallDevice: {
      type: Boolean,
      required: false,
      default: false,
    },
    item_image: {
      type: String,
      required: false,
    },
    images: {
      type: Array | Object,
      required: false,
    },
    is_last_image: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      showBackBotton: true,
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,
      containerTransform: 'none',
    };
  },

  mounted() {
    this.handleGetWindowHeight();
    window.addEventListener('resize', this.handleGetWindowHeight);
  },

  methods: {
    handleCheckAccess(access, item) {
      if (item?.highlight === 1) {
        return true;
      } else {
        return access;
      }
    },

    handleClose: function () {
      window.location.replace(window.location.origin + '/');
    },
    handlePaymentModal() {
      this.$emit('openPlansModal');
    },

    handleVideoHasEnded() {
      this.$emit('handleVideoHasEnded');
    },
    handleLoadNextVideo() {
      this.$emit('handleNext', true);
    },

    handleCheckMoves(showController) {
      this.showBackBotton = showController;
      this.$emit('handleCheckMoves', showController);
    },

    handleTouchStart(e) {
      this.startX = e.clientX || e.touches[0].clientX;
      this.startY = e.clientY || e.touches[0].clientY;
    },
    handleTouchMove(e) {
      this.endX = e.clientX || e.touches[0].clientX;
      this.endY = e.clientY || e.touches[0].clientY;
    },

    handleTouchEnd(e) {
      if (!this.smallDevice) {
        return;
      }
      const diffY = this.startY - this.endY;
      const diffX = this.startX - this.endX;
      const swipeThreshold = 500;

      const absDiffY = Math.abs(diffY);

      if (absDiffY < swipeThreshold || absDiffY < diffX) {
        this.containerTransform = 'none';
        return;
      }

      if (diffY > swipeThreshold) {
        if (absDiffY > swipeThreshold * 2) {
          return;
        }

        this.containerTransform = `translateY(-${diffY}px)`;
        setTimeout(() => {
          this.containerTransform = 'none';
          this.$emit('handleNext');
        }, 500);
      } else if (diffY < -swipeThreshold) {
        if (absDiffY > swipeThreshold * 2) {
          return;
        }

        this.containerTransform = `translateY(${-diffY}px)`;

        setTimeout(() => {
          this.containerTransform = 'none';
          this.$emit('handlePrev');
        }, 500);
      } else {
        this.containerTransform = 'none';
      }
    },

    handleSwipeChange(index) {
      this.$emit('handleSwipeChange', index);
    },
    handleGetWindowHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    handleFullScreen(){
      this.$emit('handleTriggerFullScreen')
    },
    handleReturnUrl(){
        if(this?.flix?.video_url instanceof Object){
          return this?.flix?.video_url?.link
        }
        else{
          return this?.flix?.video_url
        }
      }
  },
};
</script>

<style scoped>
.video_pc {
  position: relative;
  z-index: 2;
  width: 560px;
  background-color: #000000c9;
  overflow: hidden;
  height: 100%;
}

@media (min-width: 1024px) {
  .video_pc {
    width: 460px;
  }
}

@media (max-width: 768px) {
  .video_pc {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 768px) {
  .small-top-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 52px;
    z-index: 3;
    display: block !important;
    padding: 20px;
  }

  .small-top-header-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    color: white;
    font-weight: 900;
  }

  .title-text-white {
    color: white;
    text-wrap: nowrap;
    word-break: keep-all;
  }

  .video-player-container {
    height: 100%;
    max-height: 100%;
  }
}
.small-top-header {
  display: none;
}
.video-player-container {
  position: relative;
  z-index: 2;
  width: 100%;
  overflow: hidden;
  display: grid;
  place-items: center;
  height: calc(var(--vh, 1vh) * 100);
  min-height: -webkit-fill-available;
}

.loader-triangle {
  position: relative;
  width: 48px;
  height: 48px;
}
.loader-triangle:before,
.loader-triangle:after {
  content: '';
  display: block;
  border: 32px solid transparent;
  border-top-color: #fff;
  position: absolute;
  left: 0;
  top: 0;
  animation: weld-rotate 2s infinite ease-in;
}
.loader-triangle:before {
  border-color: transparent transparent transparent #198754;
  animation-delay: 0.5s;
}
@keyframes weld-rotate {
  0%,
  25% {
    transform: rotate(0deg);
  }
  50%,
  75% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner-border-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.pay-btn-container {
  position: absolute;
  top: 40%;
  left: 30%;
  width: 250px;
  background: #0f4c47;
  border-radius: 10px;
  z-index: 3;
  justify-content: center;
  padding: 15px;
  align-items: center;
  display: flex;
  color: white;
  font-size: 20px;

  .lock-icon {
    margin-right: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;

    i {
      font-size: 13px;
    }
  }
}
.pay-btn-container .lock-icon::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 30px;
  height: 30px;
  background: #252727bd;
  border-radius: 50%;
  z-index: -1;
}
.pay-btn-container:hover {
  cursor: pointer;
  background: #0f4c47;
}

@media screen and (max-width: 768px) {
  .pay-btn-container {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.video_pc {
  transition: transform 0.3s ease;
}

.swipe-up {
  transform: translateY(-150px);
}

.swipe-down {
  transform: translateY(150px);
}
</style>
